import styled from 'styled-components'

export const ShareLayout = styled.div`
  height: 100vh;
  min-width: 'max-content';
  min-height: 768px;
  background-color: var(--task-eva-content-bg);
  display: flex;
  flex-direction: column;
`
export const Content = styled.div`
  flex: 1;
  overflow: auto;
`
